import type { ReactNode } from 'react'
import { useAuth } from '@/shared/lib/auth/auth-context'
import { canSeeRealReconciliation } from '@/shared/lib/auth/tenant-constants'

/**
 * Renders the REAL reconciliation screen for tenants on the real module
 * (RECONCILIATION_REAL_TENANT_IDS, e.g. 40) and the legacy MOCK/"upgrade"
 * screen for everyone else. Used at the route level so a direct URL also
 * resolves to the right screen for the tenant.
 */
export function ReconTenantView({ real, mock }: { real: ReactNode; mock: ReactNode }) {
  const { user } = useAuth()
  return <>{canSeeRealReconciliation(user) ? real : mock}</>
}
